<template>

    <static-vanilla :page="pageName"></static-vanilla>

</template>

<script>
import UserFlow from '@/modules/userFlow'

import StaticVanilla from '@/components/StaticVanilla'

export default {

    name: 'about',

    components: {StaticVanilla},

    data () {
        return  {
            pageName: 'about'
        }
    },

    mounted() {
        UserFlow.setPage(this, this.pageName)
    }
}
</script>